import { ACTION_MAP, INIT_STATE } from "./cube-map";
import type { Action } from "./cube-map";

export class Cube {
  state = INIT_STATE.slice();
  reset() {
    this.state = INIT_STATE.slice();
  }
  action(action: Action) {
    const m = ACTION_MAP[action];
    const s = Array(INIT_STATE.length);
    for (let i = 0; i < s.length; i++) {
      s[i] = this.state[m[i]];
    }
    this.state = s;
  }

  toString() {
    return this.state.map((i) => i[0]).join("");
  }
}
